/*global $:false */

import RecordmImporterStatsM from "./recordm.importer.model.stats.js";

const ImporterStatsSearchM = function(core, defaultSortFieldName, defaultSortOrder) {
    const size = 30;
    let from = 0;

    let query = "*";
    let filter;

    const defaultSortField = defaultSortFieldName || "row_num";
    let sortField = defaultSortField;
    let sortAsc =  defaultSortOrder === "asc";

    const statsM = new RecordmImporterStatsM(core);

    const doSearch = function(newQuery, filter, from, size, sortField, sortAsc, successCb) {
        const event = {
            simpleSearch: true
        };

        query = newQuery || query;

        const searchQuery = (filter !== undefined
                       ? "(" + filter + ") AND (" + query + ")"
                       : query);

        $.ajax({
            url: ("recordm/importer-stats/search?q=" + encodeURIComponent(searchQuery) +
                  "&from=" + from + "&size=" + size + "&sort=" + sortField + "&ascending=" + sortAsc),
            type: "GET",
            xhrFields:{
                withCredentials: true
            },
            success: function(response) {
                if(successCb) {
                    successCb(response.hits);
                } else{
                    statsM.addStats(response.hits);
                    event.stats = statsM;

                    core.publish("recordm:search:finished", event);
                }
            },
            error: function(req) {
                event.status = req.status;
                event.errorCode = req.status;
                event.statusText = req.statusText;
                event.response = req.responseText;

                core.publish("recordm:search:finished", event);
            }
        });
    };

    return {
        getStatsFor: function(importId){
            const baseQuery = "import_id:\"" + importId + "\"";

            //We always have to get the updated import "summary" statistics together with existing "line" statistics
            doSearch(baseQuery, "type:\"summary\"", 0, 1, "start_date", true, function(summaryStatHits) {
                const lastRowNum = statsM.getLineStatsForImportId(importId)
                                       .map((row) => row.getRowNum())
                                       .sort()
                                       .pop();

                const query = baseQuery + (lastRowNum ? " AND row_num:>" + lastRowNum : "");

                doSearch(query, "type:\"line\"", 0, size, "row_num", true, function(lineStatsHits) {
                    const allStats = {
                        total: lineStatsHits.hits.length, //We only care about the Line Stats quantity
                        hits: summaryStatHits.hits.concat(lineStatsHits.hits)
                    };

                    const statsM = new RecordmImporterStatsM(core);
                    statsM.addStats(allStats);

                    core.publish("recordm:search:rm-importer-stats:success", {
                        import_id: importId,
                        stats:statsM,
                        simpleSearch: true
                    });
                });
            });
        },
        doSearch: function(newQuery){
            doSearch(newQuery, filter, from, size, sortField, sortAsc);
        },
        getRowsPerPage: function(){
            return size;
        },
        getCurrentQuery: function(){
            return query;
        },
        refresh: function(newSortField, newSortAsc){
            let rowsToFetch = size;
            const numStats = statsM.getNumStats();

            if (numStats > size) {
                rowsToFetch = numStats;
            }

            statsM.clear();
            from = 0;

            if(newSortField !== undefined){
                sortField = newSortField;
            }

            if(newSortAsc !== undefined){
                sortAsc = newSortAsc;
            }

            doSearch(query, filter, from, rowsToFetch, sortField, sortAsc);
        },
        reset: function() {
            statsM.clear();
            from = 0;
            query = "*";
            sortField =  defaultSortField;
            sortAsc = true;
        },
        abort: function(abortUri, importId) {
            $.ajax({
                url: (abortUri + "?IMPORT_ID=" + encodeURIComponent(importId)),
                type: "DELETE",
                xhrFields:{
                    withCredentials: true
                }
            });
        },
        filterSummaryStats: function() {
            filter = "type:\"summary\"";
        },
        filterLineStatsFor: function(importId) {
            filter = "type:\"line\" AND import_id:\"" + importId + "\"";
        },
        loadMoreData: function() {
            from += size;
            doSearch(query, filter, from, size, sortField, sortAsc);
        },
        sort: function(newSortField, newSortAsc) {
            this.refresh(newSortField, newSortAsc);
        },
        setDefaultSort: function(newSortField, newSortAsc) {
            if(newSortField !== undefined){
                sortField = newSortField;
            }

            if(newSortAsc !== undefined){
                sortAsc = newSortAsc;
            }
        },
        isSorted: function (){
            // it is always sorted, it sorts by "row_num" by default
            return true;
        },
        isSortAscending: function (){
            return sortAsc;
        },
        getSortField: function (){
            return sortField;
        },

        // functions to make compatible with simpleSearchM
        getFilters: function() {
            return []
        },
        setQueryFilter: function() {}
    }
};

export default ImporterStatsSearchM;
